import Vue from "vue";
import store from "./store";
import "./pollyfills";
import VueRouter from "vue-router";
import VueHtml2Canvas from "vue-html2canvas";
import VueRouterPrefetch from "vue-router-prefetch";
import VueNotify from "vue-notifyjs";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import {AuthenticateAndLogin} from "src/util/LoginProcess.js"
import {logout} from "src/util/LogoutProcess"
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";


// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import SideBar from "./components/UIComponents/SidebarPlugin";

// router setup
import routes from "./routes/routes";

// library imports
import "./assets/sass/paper-dashboard.scss";
import "./assets/sass/demo.scss";

import "./registerServiceWorker";
import Vuelidate from "vuelidate";

import {initDatadog} from "@/util/InitDatadog.js"
import { datadogRum } from "@datadog/browser-rum";

// plugin setup
Vue.use(VueRouter);
Vue.use(VueRouterPrefetch);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(VueNotify);
Vue.use(SideBar);
Vue.use(Vuelidate);
Vue.use(ElementUI);
Vue.use(VueHtml2Canvas);
locale.use(lang);

// configure router
const router = new VueRouter({
    routes, // short for routes: routes
    linkActiveClass: "active",
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.beforeEach((to, from, next) => {
    console.log('Router::BeforeEach::Checking Route')
    if(to.matched.some(record => record.meta.requiresAuth)) {
        console.log('Router::BeforeEach::Route Requires Authorization')
        if(!store.getters['currentUser/isUserLoggedIn']) {
            console.log('Router::BeforeEach::User is not poperly logged in. Logging Out')
            logout()
        }
        console.log('Router::BeforEach::User is correctly logged in. Continuing Routing.')

      const role = store.getters["currentUser/getCurrentUsersRole"];
      console.log("inside Role ", role);
      const allowedRoles = ['MANAGEMENT','PRACTICE-MANAGEMENT', 'SERVICE', 'PROVIDER', 'COACH'];
  
      if (to.matched.some((record) => record.meta.requiresRole)) {
        console.log("inside the role condition");
          if (allowedRoles.includes(role)) {
              next(); // allowed
              console.log("Router::BeforEach::User is Role is "+ role);
          } else {
              next({ path: "/UnauthorizedPage" }); // redirect to UnauthorizedPage
              console.log("Router::BeforEach::Unauthorized User Role is "+  role);
          }
      } else {
          next(); // no role restriction
          console.log("Router::BeforEach::User is role is correct. Continuing Routing.");
      }
    }
 if (to.meta && to.meta.title) {
     document.title = to.meta.title;
 }
    next()
})

// Manually Give Page Information to Datadog
router.afterEach((to, from) => {
    console.log('Router::Routed to: ', to.name)
    datadogRum.startView({
        name: to.name
    })
})

//Authenticate and Login
AuthenticateAndLogin().then(authenticationResult => {
    if(authenticationResult) {
        console.log("Main::Authentication Succesfull.")
        // Initialize Application
        const app = new Vue({
            el: "#app",
            store,
            render: h => h(App),
            router
        });
        // Mount app
        window.app = app
        initDatadog()
    }
    else {
        console.log("Main::Authentication Failed. Calling Logout Process")
        logout()
    }
})




